import React from 'react';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';
import SectionTitle from '../../components/Common/SectionTitle';

// Service Image Icons (style2)
import mainIcon5 from '../../assets/img/service/style2/main-img/5.png';
import hoverIcon5 from '../../assets/img/service/style2/hover-img/5.png';
import mainIcon2 from '../../assets/img/service/style2/main-img/2.png';
import hoverIcon2 from '../../assets/img/service/style2/hover-img/2.png';
import mainIcon3 from '../../assets/img/service/style2/main-img/3.png';
import hoverIcon3 from '../../assets/img/service/style2/hover-img/3.png';
import mainIcon4 from '../../assets/img/service/style2/main-img/4.png';
import hoverIcon4 from '../../assets/img/service/style2/hover-img/4.png';
import mainIcon1 from '../../assets/img/service/style2/main-img/1.png';
import hoverIcon1 from '../../assets/img/service/style2/hover-img/1.png';
import mainIcon6 from '../../assets/img/service/style2/main-img/6.png';
import hoverIcon6 from '../../assets/img/service/style2/hover-img/6.png';

const ServiceBusiness = () => {
    return (
        <div id="rs-service-business" className="rs-services style3 pt-120 pb-120 md-pt-80 md-pb-80">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Business Services"
                    titleClass="title testi-title"
                    title="Business Development Services"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item pink-bg" prefix="01" mainIcon={mainIcon5} hoverIcon={hoverIcon5} Title="Market Analysis & Research" serviceURL="market-analysis" Text="Comprehensive market research and competitive analysis to identify growth opportunities." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item purple-bg" prefix="02" mainIcon={mainIcon2} hoverIcon={hoverIcon2} Title="Business Strategy Development" serviceURL="business-strategy" Text="Strategic planning, go-to-market roadmaps, and operational alignment." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item aqua-bg" prefix="03" mainIcon={mainIcon3} hoverIcon={hoverIcon3} Title="Market Entry & Expansion" serviceURL="market-entry" Text="Feasibility, regulatory guidance and local partner sourcing for market entry." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item paste-bg" prefix="04" mainIcon={mainIcon4} hoverIcon={hoverIcon4} Title="Strategic Partnerships & Alliances" serviceURL="partnerships-alliances" Text="Identify and negotiate partnerships that accelerate growth and access new channels." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item green-bg" prefix="05" mainIcon={mainIcon1} hoverIcon={hoverIcon1} Title="Sales & Marketing Optimization" serviceURL="sales-marketing" Text="Customer acquisition strategies, CRM tuning, and performance marketing to boost revenue." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item" prefix="06" mainIcon={mainIcon6} hoverIcon={hoverIcon6} Title="Recruiting & Staffing" serviceURL="recruiting-staffing" Text="Strategic recruiting, staffing, and HR solutions to support your growth." />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceBusiness;
